module.exports = __webpack_public_path__ + "static/media/package_design_ui_ux.5f9c4ca0.svg";